import { IBookingStorage } from 'interfaces'

const STORAGE_KEY_PRENOTATIONS = 'edisu_residenze_booking'
const STORAGE_KEY_JWT_TOKEN = 'edisu_residenze_jwt_access_token'
const STORAGE_KEY_JWT_REFRESH_TOKEN = 'edisu_residenze_jwt_refresh_token'
const STORAGE_KEY_JWT_CHANGE_TOKEN = 'edisu_residence_jwt_change_token'
const STORAGE_KEY_LANGUAGE = 'i18nextLng'

const getAccessToken = (): string | null => {
  return localStorage.getItem(STORAGE_KEY_JWT_TOKEN)
}

const getRefreshToken = (): string | null => {
  return localStorage.getItem(STORAGE_KEY_JWT_REFRESH_TOKEN)
}
const getChangeToken = (): string | null => {
  return localStorage.getItem(STORAGE_KEY_JWT_CHANGE_TOKEN)
}

const saveTokens = (accessToken?: string | null, refreshToken?: string | null, changeToken?: string | null) => {
  !!accessToken && localStorage.setItem(STORAGE_KEY_JWT_TOKEN, accessToken)
  !!refreshToken && localStorage.setItem(STORAGE_KEY_JWT_REFRESH_TOKEN, refreshToken)
  !!changeToken && localStorage.setItem(STORAGE_KEY_JWT_CHANGE_TOKEN, changeToken)
}

const removeTokens = () => {
  localStorage.removeItem(STORAGE_KEY_JWT_TOKEN)
  localStorage.removeItem(STORAGE_KEY_JWT_REFRESH_TOKEN)
  localStorage.removeItem(STORAGE_KEY_JWT_CHANGE_TOKEN)
}

const removeChangeTokens = () => {
  localStorage.removeItem(STORAGE_KEY_JWT_CHANGE_TOKEN)
}

const getSavedBooking = (uuid: string) => {
  const bookings = getSavedBookings()
  if (bookings) {
    return bookings.find((booking) => booking.uuid === uuid)
  }
}

const removeBooking = (uuid: string) => {
  const bookings = getSavedBookings()
  if (!!bookings) {
    const index = bookings.findIndex((booking) => booking.uuid === uuid)
    if (index > 0) {
      bookings.splice(index, index)
      saveBookings(bookings)
    }
  }
}

const saveBookings = (bookings: IBookingStorage[]) => {
  localStorage.setItem(STORAGE_KEY_PRENOTATIONS, JSON.stringify(bookings))
}

const saveBooking = (booking: IBookingStorage) => {
  const savedBookings = getSavedBookings() ?? []
  savedBookings[0] = booking //TODO per ora setto solo un booking nello storage
  localStorage.setItem(STORAGE_KEY_PRENOTATIONS, JSON.stringify(savedBookings))
}

const getSavedBookings = (): IBookingStorage[] | undefined => {
  const item = localStorage.getItem(STORAGE_KEY_PRENOTATIONS)
  if (!!item) {
    const bookings: IBookingStorage[] = JSON.parse(item)
    return bookings
  }
}

const getLanguage = (): string | null => {
  return localStorage.getItem(STORAGE_KEY_LANGUAGE)
}

const saveLanguage = (language: string) => {
  localStorage.setItem(STORAGE_KEY_LANGUAGE, language)
}
const storageService = {
  getSavedBooking,
  saveBooking,
  getAccessToken,
  removeTokens,
  removeChangeTokens,
  getRefreshToken,
  saveTokens,
  getChangeToken,
  getSavedBookings,
  removeBooking,
  getLanguage,
  saveLanguage,
}

export default storageService
